/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: exports a function, not a component. */

// Excel parses text starting with =, +, -, @ or tab as a formula when it is typed or imported untyped.
const FORMULA_PREFIX = /^[=+\-@\t]/;

export function hasFormulaPrefix(text: string): boolean {
  return FORMULA_PREFIX.test(text);
}
